import i18n from '@/utils/i18n';

const filters =
  [
    {
      name: "title",
      id: "title",
      placeholder: i18n.t('form.title_placeholder'),
      value: "",
      type: "text",
      label: i18n.t('form.title'),
      main: false
    },
    {
      name: "code",
      id: "code",
      placeholder: i18n.t('form.code_placeholder'),
      value: "",
      type: "text",
      label: i18n.t('form.code'),
      main: false
    },
  ];

export default filters
